import { render } from "./SuperFrase.vue?vue&type=template&id=b9470790&scoped=true"
import script from "./SuperFrase.vue?vue&type=script&lang=js"
export * from "./SuperFrase.vue?vue&type=script&lang=js"

import "./SuperFrase.vue?vue&type=style&index=0&id=b9470790&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9470790"]])

export default __exports__